<template>
  <div 
    style="text-align:center;height:100%;"
    :style="{backgroundColor: item.color}"
  >
  <iframe :src="item.url" border="0" style="border:0;width: 950px;height:100%;"/>
  </div>
</template>
<script>
export default {
  props: {
    enterprise: {
      type: Object,
      required: true,
    },
  },
  computed: {
    item () {
      return this.$store.state.app.totemActiveMenuItem
    },
  },
}
</script>

